export enum SpaPriorityTier {
  PRIORITY_1 = 1,
  PRIORITY_2 = 2,
  PRIORITY_3 = 3,
}

// Status the SPA agreement is sent with; the same lowercase values on every wire field.
export enum SpaStatus {
  LIVE = 'live',
  PLANNING = 'planning',
}

// Wire values of `project.kind` on the Attributes read and the project-customers response. A
// project's customers are derived by the BE and locked; a program, and a null kind (unknown
// external type), is sent as All Customers.
export enum AttributeProjectKind {
  PROGRAM = 'program',
  PROJECT = 'project',
}
